var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-have-examine"},[_c('examineModel',{attrs:{"examineType":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }